import AddEditProduct from './AddEditProduct';
import ToggleActive from './ToggleActive';

const Modals = ({ modal, activeProduct, setModal, refresh }) => {
  if (!modal) return null;

  const modals = {
    addEdit: AddEditProduct,
    toggleActive: ToggleActive,
  };

  const Component = modals[modal];
  if (!Component) return null;

  return (
    <Component product={activeProduct} setModal={setModal} refresh={refresh} />
  );
};

export default Modals;
